// Initialize Swiper for multiple sections with unique navigation
const MOBILE_BREAKPOINT = 750; // matches theme CSS breakpoint

function shouldUseSlider(container) {
  const mobileLayout = container.dataset.mobileLayout;
  const desktopLayout = container.dataset.desktopLayout;
  const isMobileViewport = window.innerWidth < MOBILE_BREAKPOINT;
  return isMobileViewport ? mobileLayout === 'carousel' : desktopLayout === 'carousel';
}

function initializeSwiper() {
  if (typeof Swiper === 'undefined') return false;

  const swiperContainers = document.querySelectorAll('.swiper.featured--coll-slider');
  if (!swiperContainers.length) return false;

  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  let initialized = 0;

  swiperContainers.forEach((container) => {
    const wantsSlider = shouldUseSlider(container);

    // Layout says "grid" for this breakpoint — tear down if needed, skip init
    if (!wantsSlider) {
      if (container.swiper) {
        container.swiper.destroy(true, true);
      }
      return;
    }

    // Already initialized and still wants slider — nothing to do
    if (container.swiper) {
      initialized++;
      return;
    }

    const section = container.closest('[data-id]');
    const sectionId = section ? section.dataset.id : null;

    if (!sectionId) {
      console.warn('Section ID not found for slider');
      return;
    }

    try {
      const swiper = new Swiper(container, {
        slidesPerView: 4,
        slidesPerGroup: 2,
        spaceBetween: 2,
        speed: isTouchDevice ? 400 : 300,

        touchRatio: isTouchDevice ? 1.5 : 2,
        resistanceRatio: isTouchDevice ? 0.25 : 0.5,

        freeMode: {
          enabled: true,
          momentum: true,
          momentumRatio: isTouchDevice ? 1.0 : 0.8,
          momentumBounce: isTouchDevice,
          momentumBounceRatio: 0.5,
        },

        mousewheel: {
          enabled: true,
          forceToAxis: true,
          sensitivity: 0.5,
        },

        navigation: {
          nextEl: `#collection-${sectionId} .swiper-button-next`,
          prevEl: `#collection-${sectionId} .swiper-button-prev`,
        },

        breakpoints: {
          320: { slidesPerView: 1.5, touchRatio: isTouchDevice ? 1.3 : 2.5 },
          640: { slidesPerView: 2.5, touchRatio: isTouchDevice ? 1.4 : 2.2 },
          768: { slidesPerView: 3.5, touchRatio: isTouchDevice ? 1.5 : 2 },
          1024: { slidesPerView: 4 },
        },

        on: {
          touchEnd() {
            if (isTouchDevice) {
              const progress = this.progress;
              if (progress >= 0.98) {
                setTimeout(() => this.setTranslate(this.maxTranslate()), 50);
              } else if (progress <= 0.02) {
                setTimeout(() => this.setTranslate(0), 50);
              }
            }
          }
        }
      });

      initialized++;
    } catch (error) {
      console.error(`Swiper error for section ${sectionId}:`, error);
    }
  });

  if (!document.getElementById('swiper-css')) {
    const style = document.createElement('style');
    style.id = 'swiper-css';
    style.textContent = `
      .swiper{touch-action:pan-x pan-y;user-select:none;-webkit-touch-callout:none}
      .swiper-slide{will-change:transform;backface-visibility:hidden;transform:translateZ(0)}
      @media (hover:hover){.swiper{transition:transform 0.2s ease}}
      @media (hover:none){.swiper{transition:none!important}}
    `;
    document.head.appendChild(style);
  }

  return initialized > 0;
}

function init(attempt = 0) {
  if (initializeSwiper() || attempt > 5) return;
  setTimeout(() => init(attempt + 1), 300);
}

const initAndRemovePreload = () => {
  init();
  const preloadElements = document.querySelectorAll('.slider-component-desktop');
  preloadElements.forEach(el => el.classList.remove('preload'));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAndRemovePreload);
} else {
  initAndRemovePreload();
}

window.addEventListener('load', initAndRemovePreload);

// Re-evaluate on resize/orientation change (debounced)
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(initAndRemovePreload, 200);
});

if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setTimeout(initAndRemovePreload, 100);
        observer.unobserve(entry.target);
      }
    });
  });

  const sections = document.querySelectorAll('[data-id]');
  sections.forEach(section => {
    if (section.querySelector('.swiper.featured--coll-slider')) {
      observer.observe(section);
    }
  });
}

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    setTimeout(initAndRemovePreload, 200);
  });
}